/* eslint-disable import/no-cycle */
import {
  BillVersion,
  IdenticalBill,
  RelatedBill,
} from '@enview/interface/types//bills/Bill';
import BillRelationshipType from '@enview/interface/types/bills/BillRelationshipType';
import { faCaretDown } from '@fortawesome/free-solid-svg-icons/faCaretDown';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ReactElement, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { State } from '../../dux/@types';
import featureFlags, { FrontendFeature } from '../../featureFlags';
import { mobileMediaQuery } from '../../helpers/mediaQueries';
import Hideable from '../Hideable';
import './BillRelationships.scss';
import RelatedBillItem from './RelatedBillItem';

type BillRelationshipsProps = {
  identicalBills: IdenticalBill[];
  relatedBills: RelatedBill[];
  billVersions: BillVersion[];
  billDetailNumber: string;
};

const relatedBillsTitle = (
  <h3 className="react-sanfona-item-title">
    Related Bills
    <FontAwesomeIcon icon={faCaretDown} size="lg" />
  </h3>
);

const BillRelationships = (props: BillRelationshipsProps): ReactElement => {
  const { identicalBills, relatedBills, billVersions, billDetailNumber } = props;
  const organizationUser = useSelector(
    (state: State) => state.account.organizationUser
  );

  // sorting identical bills by highest to lowest jaccard score
  const sortedIdenticalBills = useMemo(() => {
    return [...identicalBills].sort((a, b) => {
      if (a.jaccardScore > b.jaccardScore) {
        return -1;
      }
      if (a.jaccardScore < b.jaccardScore) {
        return 1;
      }
      return 0;
    });
  }, [identicalBills])

  const getIdenticalBillItemWithRelationship = (
    identicalBill: IdenticalBill
  ): ReactElement => {
    return identicalBill && (
      <RelatedBillItem
        key={`${identicalBill.jaccardScore}-${identicalBill.identicalBillId}`}
        relationship={identicalBill.relationshipType ?? ''}
        identicalBill={identicalBill}
        billNumber={identicalBill.identicalBill.number}
        billName={identicalBill.identicalBill.name}
        billId={identicalBill.identicalBillId}
        billVersion={billVersions.find((bill) => bill.id == identicalBill.versionId)}
        billDetailNumber={billDetailNumber}
      />
    )
  };

  const getIdenticalBillItem = (identicalBill: IdenticalBill): ReactElement => {
    return identicalBill && (
      <RelatedBillItem
        key={`${identicalBill.jaccardScore}-${identicalBill.identicalBillId}`}
        relationship="highlySimilar"
        identicalBill={identicalBill}
        billNumber={identicalBill.identicalBill.number}
        billName={identicalBill.identicalBill.name}
        billId={identicalBill.identicalBillId}
        billVersion={billVersions.find((bill) => bill.id == identicalBill.versionId)}
        billDetailNumber={billDetailNumber}
      />
    )
  };

  return (
    <>
      <div>
        <Hideable title={relatedBillsTitle} expanded={!mobileMediaQuery.matches}>
          <ul className="list-paragraph-style related-bills-list">
            {relatedBills.map((bill) => {
              let relatedBill = bill.relatedBill;
              return bill ? (
                <RelatedBillItem
                  key={`${relatedBill.number}-${relatedBill.id}`}
                  relationship={bill.relationshipType}
                  billNumber={relatedBill.number}
                  billName={relatedBill.name}
                  billId={relatedBill.id}
                  billDetailNumber={billDetailNumber}
                />
              ) : (
                <></>
              );
            })}
          </ul>
          <ul className="list-paragraph-style">
            {sortedIdenticalBills.map((identicalBill) =>
                getIdenticalBillItemWithRelationship(identicalBill)
            )}
          </ul>
        </Hideable>
      </div>
    </>
  );
};

export default BillRelationships;
